import React, {useState} from 'react';
import {Button, Modal, Spinner} from "react-bootstrap";
import {PartnerCredential} from "../../Partners/models";
import { PartnerCredentialService } from '../PartnerCredentials.service';

interface RevokePartnerCredentialConfirmModalProps {
    credential: PartnerCredential;
    handleSubmitClose: () => void;
    handleRejectClose: () => void;
}

export function RevokePartnerCredentialConfirmModal(props: RevokePartnerCredentialConfirmModalProps) {
    const [saving, setSaving] = useState(false);
    const [savingError, setSavingError] = useState(false);

    const confirmSubmit = async () => {
        setSaving(true);
        setSavingError(false);

        try {
            await PartnerCredentialService.revokePartnerCredential(props.credential.id);
            setTimeout(() => {
                setSaving(false);
                props.handleSubmitClose();
            }, 100);
        } catch (e) {
            console.error('Revoking failed', e);
            setSaving(false);
            setSavingError(true);
        }
    };

    return (
        <Modal show={true} centered>
            <Modal.Header>
                <Modal.Title>Ligipääsu tühistamine</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                Kas oled kindel, et soovid ligipääsu{props.credential.name ? ` "${props.credential.name}"` : ''} tühistada?
            </Modal.Body>
            <Modal.Footer className="d-flex flex-row align-items-end justify-content-around flex-wrap mb-1">
                <Button variant="info"
                        onClick={props.handleRejectClose}
                        type="button"
                        disabled={saving}
                        className={"d-flex align-items-center"}>
                    <span className='px-2'>Loobu</span>
                </Button>
                <Button variant="danger"
                        onClick={confirmSubmit}
                        type="button"
                        disabled={saving}
                        className="d-flex align-items-center">
                    { !saving && <span className='px-2'>Tühista</span> }
                    {
                        saving &&
                        <>
                            <span className='px-2'>Tühistab…</span>
                            <Spinner size={"sm"} animation={"border"}/>
                        </>
                    }
                </Button>
            </Modal.Footer>
            {
                !saving && savingError &&
                <span className="d-flex justify-content-end text-danger px-2 pb-2">
                    Viga salvestamisel, proovi mõne hetke pärast uuesti.
                </span>
            }
        </Modal>
    );
}
